import { useEffect } from "react"
import { useContextSelector as useCS } from "use-context-selector"

import { useRequest } from "domain/core/hooks/useRequest"
import { CustomizationContext } from "domain/customization/CustomizationContext"
import { customizationSelectors } from "domain/customization/selectors"
import { UserContext } from "domain/user/UserContext"
import { userSelectors } from "domain/user/selectors"

import { mapDataToRow } from "./mappers"

export const FetchStylesContainer = () => {
  const id = useCS(UserContext, userSelectors.id)
  const update = useCS(CustomizationContext, customizationSelectors.update)

  const { data, error } = useRequest({
    url: "/v1/merchants/styles",
    sendOnStart: !!id,
  })

  useEffect(() => {
    if (!data) return

    const result = (data?.styles || []).map((item) => mapDataToRow(item))

    update?.({
      data: {
        list: result,
        error: null,
      },
    })
  }, [data, update])

  useEffect(() => {
    if (!error) return

    update?.({
      data: {
        list: null,
        error,
      },
    })
  }, [error, update])

  return null
}
